"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoText = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _tsUtils = require("@ori/ts-utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const InfoText = ({
  className,
  testId,
  text
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!(0, _tsUtils.isNonNullable)(text) || text === '') {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    variant: "caption",
    className: className,
    "data-testid": testId ?? getTestId(_constants.INFO_TEXT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircle, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: text
    })]
  });
};
exports.InfoText = InfoText;
